import type { DayTripPlanI18nEditQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingDayTripPlanI18nFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { DayTripPlanI18nFormMain } from "../_components/root";
import { dayTripPlanI18nCategoriesAndManagerStore } from "../_store/categories";
import { HeaderUpdateButton } from "./components/header/update-button/update-button";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: DayTripPlanI18nEditQuery;
};

export const DayTripPlanI18nEditPresenter = ({ serverModel, activeLangCode, navigator }: Props) => {
	const init = useInitialized({
		serverModel,
	});
	const { categoryManagerStore } = dayTripPlanI18nCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const planName = init.viewModel.name.value;

	return (
		<ProductExistingDayTripPlanI18nFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="日帰りプラン編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<DayTripPlanI18nFormMain
						dayTripPlanI18nCategoriesAndManagerStore={dayTripPlanI18nCategoriesAndManagerStore}
						hotelID={serverModel.planI18n?.hotelID}
						planID={serverModel.planI18n?.planID}
						hotelEmailAddress={init.queryData.hotelEmailAddress}
					/>
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingDayTripPlanI18nFormModelContextProvider>
	);
};

DayTripPlanI18nEditPresenter.displayName = "DayTripPlanI18nEditPresenter";
